import { TriangleSmallUpIcon } from './TriangleSmallUpIcon';

/**
 * author: Jeff Anders
 * id D7C0A028-070C-4E9B-88B8-910365A3FE41
 * name triangle-small-up
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/triangle-small-up.svg
 * tags
 * - Shape 
 */
export const TrendingUpVariantIcon = TriangleSmallUpIcon;
export default TrendingUpVariantIcon